<template>
  <edit-rule v-if="selectedUser.id" :tier="tierType" :id="selectedUser.id" />
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import EditRule from "@/views/Common/GeoBlocking/Rules/Edit/index.vue";

import { TIER } from "@/constants";

export default {
  name: "GeoblockingRuleEditWrap",
  components: {
    EditRule,
  },
  data() {
    return {
      tierType: TIER.users,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
  },
  created() {
    this.setPageTitle(this.$t("Geoblocking"));
    this.setPageSubtitle([]);
  },
};
</script>
